import React, { useState } from 'react';
import { BasketHeader } from './BasketHeader';
import { TopicItem } from './TopicItem';
import { ChevronDown } from 'lucide-react';
import { BasketMenu } from './BasketMenu';
import BasketStats from './BasketStats';

const highlightText = (text, searchTerm) => {
  if (!searchTerm) return text;
  const parts = text.split(new RegExp(`(${searchTerm})`, 'gi'));
  return parts.map((part, index) => 
    part.toLowerCase() === searchTerm.toLowerCase() ? 
      <span key={index} className="bg-yellow-200">{part}</span> : part
  );
};

const StudyModeBasketCard = ({ 
  basket, 
  onClick, 
  onMenuClick,
  onAddClick,
  searchTerm, 
  workspaceId,
  workspaceName,
  onRevealBasket,
  isRevealed,
  hiddenTopics = [],
  onRevealTopic,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const topics = basket.topics || [];
  const visibleTopics = topics.slice(0, 4);

  const handleClick = (e) => {
    if (!e.target.closest('.menu-button')) {
      onClick(basket.id, basket, workspaceId, workspaceName);
    }
  };

  const handleMenuClick = (action) => (e) => {
    e.stopPropagation();
    if (onMenuClick) {
      onMenuClick(basket, action);
    }
  };

  const cardClasses = `
    bg-white rounded-xl p-4 pt-2 w-full 
    transition-all duration-300 relative
    border-2 border-neutral-900
    shadow-sm
    h-[320px] flex flex-col
    cursor-pointer hover:shadow-md
  `;

  const renderTopicsList = () => {
    return visibleTopics.map((topic, index) => {
      if (hiddenTopics.includes(topic.id)) {
        return (
          <div
            key={topic.id}
            onClick={(e) => {
              e.stopPropagation();
              onRevealTopic(topic.id);
            }}
            className="cursor-pointer transition-colors duration-200 
                     bg-neutral-100 hover:bg-neutral-200
                     rounded-lg border-2 border-dashed border-neutral-300
                     flex items-center justify-center h-full"
          >
            <div className="text-center p-4">
              <div className="text-neutral-600 font-medium mb-1">Topic {index + 1}</div>
              <div className="text-neutral-400 text-sm">Click to reveal</div>
            </div>
          </div>
        );
      }

      return (
        <TopicItem 
          key={topic.id} 
          topic={topic}
          searchTerm={searchTerm}
          highlightText={highlightText}
        />
      );
    });
  };

  return (
    <div 
      className={cardClasses}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      <div className="flex justify-between items-start relative mb-0">
        <BasketHeader 
          name={basket.name}
          description={basket.description}
        />
        
        <div className="ml-auto">
          {topics.length > 0 && <BasketStats topics={topics} />}
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-2 mt-0 flex-grow overflow-hidden">
        {renderTopicsList()}
        {topics.length === 0 && (
          <div className="col-span-2 flex justify-center items-center h-full text-neutral-600 italic">
            No topics yet
          </div>
        )}
      </div>
      
      <div className="mt-auto pt-2 flex justify-between items-center border-t border-neutral-100">
        <div className="w-full flex justify-center">
          {topics.length > 4 && (
            <button
              onClick={handleClick}
              className="text-blue-600 hover:text-blue-800 transition duration-300 text-center flex items-center justify-center"
            >
              <ChevronDown size={18} className="mr-1" />
              <span className="text-sm font-medium">View All ({topics.length} topics)</span>
            </button>
          )}
        </div>

        <div className={`absolute bottom-2 right-2 flex items-center space-x-2 ${isHovered ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}>
          <BasketMenu
            onEdit={handleMenuClick('edit')}
            onDelete={handleMenuClick('delete')}
          />
        </div>
      </div>
    </div>
  );
};

export default StudyModeBasketCard; 